import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

function CardContent({ children, className }) {
  return (
    <div
      className={cx(
        "border border-gray-200 rounded-md shadow-md hover:shadow-lg",
        className
      )}
    >
      {children}
    </div>
  );
}

CardContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

CardContent.defaultProps = {
  className: "",
};

export default CardContent;
